"use client";

import AppImage from "@/components/ui/AppImage";
import { useEffect, useRef } from "react";

function ProductCard({
    title,
    summary,
    href,
}: {
    title: string;
    summary: string;
    href: string;
}) {
    return (
        <div className="card overflow-hidden">
            <div className="relative h-48 bg-[#1d2233]">
                <AppImage
                    src="https://ashevillegemmine.com/cdn/shop/files/PeacockOreedit3.jpg?v=1684344284&width=1800"
                    alt={title}
                    fill
                    className="object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1d2233]" />
            </div>
            <div className="p-6">
                <h3
                    className="mb-3"
                    style={{
                        fontFamily: "var(--font-serif)",
                        fontSize: "1.3125rem",
                        fontWeight: 400,
                        color: "var(--color-white)",
                        lineHeight: 1.2,
                    }}
                >
                    {title}
                </h3>
                <p className="type-body mb-5">{summary}</p>
                <a
                    href={href}
                    style={{
                        color: "var(--color-white)",
                        fontSize: "0.8125rem",
                        fontWeight: 600,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        textDecoration: "none",
                        transition: "color var(--transition-fast)",
                    }}
                    className="hover:text-[#e24d4d]"
                >
                    View Specs →
                </a>
            </div>
        </div>
    );
}

export default function AboutHeader() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.1 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="section-navy-mid"
            style={{ paddingTop: "80px", paddingBottom: "80px" }}
        >
            <div
                className="px-6 lg:px-12"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 reveal reveal-delay-1">
                    <ProductCard
                        title="Antimony Concentrate (Sulfide)"
                        summary="Primary ore-based concentrate (typically 40–60% Sb, subject to final assay)."
                        href="/products/sulfide-concentrate"
                    />
                    <ProductCard
                        title="Intermediate (Calcine)"
                        summary="Processed intermediate material tailored to refinery specifications."
                        href="/products/calcine"
                    />
                    <ProductCard
                        title="Antimony Metal / ATO"
                        summary="Finished or semi-finished products available under structured arrangements."
                        href="/products/metal-ato"
                    />
                </div>
            </div>
        </section>
    );
}